export default String.raw`
{% include 'partials/common/date-format.html' -%}

{% assign coupons = customer-profile.Coupons -%}
{% assign couponString = customer-profile.CouponQueryGET | H -%}
{% assign paginationPageNo = coupons.PageNo -%}
{% assign anyCoupon = false -%}

<div class="eshop__table-container coupons">
    <table data-template="partials/customer-profile/discounts/coupon-details.html">
        <colgroup>
            <col style="width:250px">
            <col style="width:150px">
        </colgroup>
        <thead>
            <tr>
                <th class="id">{{ translations.CouponCode | Capitalize }}</th>
                <th>{{ translations.Value }}</th>
            </tr>
        </thead>

{% if coupons.TotalItems > 0 -%}
    {% assign anyCoupon = true -%}
    {% for coupon in coupons.Coupons -%}
        <tbody>
            <tr tabindex="0" class="row can-hover load-deeper-lvl-js parent-container-reload-js" data-id="{{ coupon.Id }}" data-url="{{ page.Url }}?{{ couponString }}={{ coupon.Id }}&deeper-lvl&tab=coupon-details">
                <td class="id">
                    {% if coupon.Code != null -%}
                        {{ coupon.Code | H }}
                    {% else -%}
                        {{ translations.Coupons }}
                    {% endif -%}
                </td>
                <td>
					{% if coupon.Type == 0 -%}
						{{coupon.Discount | Normalize}} %
					{% elseif coupon.Type == 1 -%}
						{{coupon.Discount | ToPrice}} {{currencyExt}}
					{% elseif coupon.Type == 2 -%}
						{{translations.FreeDelivery}}
					{% elseif coupon.Type == 3 -%}
						{{coupon.Discount | ToPrice}} {{currencyExt}}
					{% elseif coupon.Type == 4 -%}
						{{coupon.Discount | Normalize}} %
					{% endif -%}
                </td>
                <td></td>
            </tr>
        </tbody>
    {% endfor -%}
{% endif -%}
    </table>
</div>

{% if coupons.TotalItems > 0 %}
    {% include 'partials/common/pagination.html' -%}
{% endif %}
{% unless anyCoupon -%}
    <div class="no-data">{{ translations.NoCouponsInfo }}</div>
{% endunless -%}
`